import { MediaPlayerStatus } from "@/models/frontend-only/MediaPlayerStatus";

export const useAltAudioPlayback = defineStore("alt-audio-playback", () => {
  const maxVolume = 1;
  const fadeTime = 3;

  const audioContext = new (window.AudioContext || window.webkitAudioContext)();

  const debug = useDebug();
  const gainNode = audioContext.createGain();
  let audio: HTMLAudioElement | null = null; // new Audio();
  // audio.crossOrigin = "anonymous";
  let track: MediaElementAudioSourceNode | null = null;
  // track.connect(gainNode).connect(audioContext.destination);
  //track.connect(audioContext.destination);

  function initAudio(url: string) {
    audio = new Audio(url);

    (window as any).a = audio;
    audioContext.resume();

    audio.crossOrigin = "anonymous";
    track = audioContext.createMediaElementSource(audio);
    track.connect(gainNode).connect(audioContext.destination);

    audio.addEventListener("error", (e) => {
      console.error("audio playback error", e);
      const toasts = useToastStore();
      toasts.errorToast("Error playing audio");
      error.value = e.message;
      status.value = MediaPlayerStatus.Error;
    });

    audio.addEventListener("play", () => {
      status.value = MediaPlayerStatus.Playing;

      if (!audio || audio.duration === 0) {
        return;
      }

      const audioCurrentTime = audio.currentTime;

      /**
       * if near the start, then set the ramp going up
       */
      if (audioCurrentTime <= fadeTime) {
        const vol = (audioCurrentTime / fadeTime) * maxVolume;

        gainNode.gain.setValueAtTime(vol, audioContext.currentTime);
        gainNode.gain.linearRampToValueAtTime(
          maxVolume,
          audioContext.currentTime - audioCurrentTime + fadeTime,
        );
      } else {
        // set to normal volume otherwise
        gainNode.gain.setValueAtTime(maxVolume, audioContext.currentTime);
      }

      let secondsIntoFade = 0;
      if (audioCurrentTime > audio.duration - fadeTime) {
        secondsIntoFade = audioCurrentTime - (audio.duration - fadeTime);
      }

      let vol = maxVolume;
      if (secondsIntoFade > 0) {
        vol = (1 - secondsIntoFade / fadeTime) * maxVolume;
      }

      /**
       * At the end we want to fade out, so set the start value
       */

      if (audio.duration - fadeTime - audioCurrentTime > 0) {
        gainNode.gain.setValueAtTime(
          vol,
          audioContext.currentTime +
            audio.duration -
            fadeTime -
            audioCurrentTime,
        );
      } else {
        gainNode.gain.setValueAtTime(vol, audioContext.currentTime);
      }

      gainNode.gain.linearRampToValueAtTime(
        0,
        audioContext.currentTime + audio.duration - audioCurrentTime,
      );
    });

    audio.addEventListener("pause", () => {
      status.value = MediaPlayerStatus.Paused;
      gainNode.gain.cancelScheduledValues(audioContext.currentTime);
    });
    audio.addEventListener("ended", () => {
      status.value = MediaPlayerStatus.Ended;
    });
    audio.addEventListener("timeupdate", () => {
      currentTime.value = audio!.currentTime;
      maxTime.value = audio!.duration;
    });
    audio.addEventListener("canplaythrough", startPlaying);
    audio.load();
  }

  const currentTime = ref(0);
  const maxTime = ref(0);
  const error = ref("");
  const status = ref<MediaPlayerStatus>(MediaPlayerStatus.Unloaded);
  const url = ref("");

  function startPlaying() {
    // track.connect(gainNode).connect(audioContext.destination);
    audio!.play().catch((err) => console.error("play error", err));
    audio!.removeEventListener("canplaythrough", startPlaying);
  }

  function loadUrl(_url: string) {
    debug.log("load url", _url);
    status.value = MediaPlayerStatus.Loading;
    //if audio is playing
    if (audio && !audio.paused && !audio.ended) {
      audio.pause();
    }

    error.value = "";
    initAudio(_url);
  }

  function play() {
    audio?.play().catch((err) => console.error("play error", err));
  }

  function pause() {
    audio?.pause();
  }

  function goToTime(time: number) {
    if (!audio) {
      return;
    }
    if (time >= 0 && time <= audio.duration) {
      audio.currentTime = time;
    } else {
      error.value = "Time out of range";
    }
  }

  return {
    currentTime,
    maxTime,
    error,
    status,
    url,
    play,
    pause,
    goToTime,
    loadUrl,
  };
});
